import React from "react";

const PromocionesMessage = ({ payload }) => {
  const { promociones } = payload;

  return (
    <div>
      {promociones.map((promocion, index) => (
        <div
          key={promocion.id || index}
          style={{
            marginBottom: "10px",
            marginLeft: "50px",
            paddingLeft: "10px",
            padding: "5px",
            borderRadius: "5px",
            background: "#d90e75",
            color: "#fff",
            fontSize: "0.9rem",
          }}
        >
          <strong>Promoción {index + 1}:</strong>
          <div>
            <strong>Paquete:</strong> {promocion.nombre_promocion}
          </div>
          {/* Puedes agregar más campos si es necesario */}
        </div>
      ))}
    </div>
  );
};

export default PromocionesMessage;
